<h1 class="text-dark text-xl" mat-dialog-title>Collega pratica</h1>

<div class="link-practice-content" mat-dialog-content>
  <div class="filter-row">
    <mat-form-field appearance="fill" class="w-full md:w-1/2">
      <mat-label>Filtra per marca</mat-label>
      <mat-select
        [value]="selectedBrandId"
        (selectionChange)="onBrandChange($event.value)"
        [disabled]="loading"
      >
        <mat-option [value]="null">Tutte le marche</mat-option>
        <mat-option *ngFor="let brand of brands" [value]="brand.id">
          {{ brand.codiceMarca }} - {{ brand.descrizioneMarca }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="table-wrapper">
    <table mat-table [dataSource]="practices" class="w-full">
      <ng-container matColumnDef="codicePratica">
        <th mat-header-cell *matHeaderCellDef>Codice Pratica</th>
        <td mat-cell *matCellDef="let row">{{ row.codicePratica }}</td>
      </ng-container>

      <ng-container matColumnDef="targa">
        <th mat-header-cell *matHeaderCellDef>Targa</th>
        <td mat-cell *matCellDef="let row">{{ row.targa }}</td>
      </ng-container>

      <ng-container matColumnDef="marca">
        <th mat-header-cell *matHeaderCellDef>Marca</th>
        <td mat-cell *matCellDef="let row">
          {{ row.marca?.codiceMarca }} - {{ row.marca?.descrizioneMarca }}
        </td>
      </ng-container>

      <ng-container matColumnDef="flotta">
        <th mat-header-cell *matHeaderCellDef>Flotta</th>
        <td mat-cell *matCellDef="let row">
          {{ row.flotta ? 'Si' : 'No' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="modello">
        <th mat-header-cell *matHeaderCellDef>Modello</th>
        <td mat-cell *matCellDef="let row">{{ row.modello }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="text-right">Azione</th>
        <td mat-cell *matCellDef="let row" class="text-right">
          <button
            mat-flat-button
            color="primary"
            type="button"
            [disabled]="linkingId !== null"
            (click)="onLink(row)"
          >
            Collega
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div *ngIf="!loading && practices.length === 0" class="empty-state">
      Nessuna pratica disponibile per i filtri selezionati.
    </div>

    <div *ngIf="loading" class="empty-state">Caricamento in corso...</div>
  </div>
</div>

<div mat-dialog-actions class="actions-row">
  <button mat-stroked-button type="button" (click)="cancel()">Annulla</button>
</div>
